import { Field, Textarea } from '../../../libs/gs-component-form';
import { Content } from '../../../libs/gs-component-right-rail';
import { compose } from '@xo-union/react-css-modules';
import { FormBlockColumn } from '@xo-union/tk-component-form-grid';
import { Field as FormikField, Form as FormikForm } from 'formik';
import React from 'react';
import * as Yup from 'yup';

import { EmbedItemsFragment, Maybe } from '../../../generated/graphql';
import { SharedFormProps } from '../../../helpers/useManageItem';
import { Footer } from '../../FormComponents';
import { DeleteOrDiscard } from '../DeleteOrDiscard';
import styles from './index.scss';

export const validationSchema = Yup.object().shape({
  embededCode: Yup.string().required('Embed code is required'),
  description: Yup.string(),
  title: Yup.string(),
});

export interface InitialValues {
  title?: string | null;
  embededCode?: string | null;
  id?: number | null;
  description?: string | null;
}

export const initialValues = (item?: Maybe<EmbedItemsFragment>): InitialValues => ({
  title: item?.title || '',
  embededCode: item?.embededCode || '',
  description: item?.description || '',
});

const Form: React.FC<SharedFormProps> = ({ submitForm, loading, updating, discardOrDelete, isNew, close }) => {
  return (
    <>
      <Content className={styles.content} loading={loading}>
        <FormikForm>
          <FormBlockColumn>
            <FormikField name="title" label="Title" component={Field} data-testid="title" />
          </FormBlockColumn>

          <FormBlockColumn>
            <FormikField
              data-testid="embeded-code"
              classes={compose({ container: styles.fieldContainer })}
              name="embededCode"
              placeholder="Add supported embeded playlists from Spotify, Apple Music, Soundcloud, and Tidal"
              label={false}
              component={Textarea}
            />
          </FormBlockColumn>
          <FormBlockColumn>
            <FormikField
              data-testid="description"
              classes={compose({ container: styles.fieldContainer })}
              name="description"
              placeholder="Add a short description"
              label={false}
              component={Textarea}
            />
          </FormBlockColumn>
          <DeleteOrDiscard onClick={discardOrDelete} isNew={isNew}>
            Delete item
          </DeleteOrDiscard>
        </FormikForm>
      </Content>
      <Footer primaryOnClick={submitForm} secondaryOnClick={close} showSpinner={updating} useSaveAndPreview={true} />
    </>
  );
};

export default Form;
